import React from "react";
import { getLanguageValue } from "../../utils";
import { PropertyWrapper } from "./Cards.styled";
import { FiArrowRight } from "react-icons/fi";
import { CardTraderLanguageValueType } from "magic-shared-types";

interface LanguageProps {
  language: CardTraderLanguageValueType;
  originalLanguage?: CardTraderLanguageValueType;
}

export const Langugage = ({ language, originalLanguage }: LanguageProps) => {
  const languageValue = getLanguageValue(language);
  const originallanguageValue =
    originalLanguage && getLanguageValue(originalLanguage);

  return (
    <PropertyWrapper>
      {originallanguageValue &&
        originalLanguage &&
        originalLanguage !== language && (
          <>
            <img
              src={originallanguageValue?.flag}
              alt={originallanguageValue?.label}
              style={{ width: 30, opacity: 0.4 }}
            />
            <FiArrowRight size={18} />
          </>
        )}
      <img
        src={languageValue?.flag}
        alt={languageValue?.label}
        style={{ width: 40 }}
      />
    </PropertyWrapper>
  );
};
